import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { DIGITAL_JOURNEY_BASE_URL } from '../apiConfig'

export const fetchBureau = createAsyncThunk(
    'fetchBureau',
    async ({ jwtBearer, requestBody }) => {
        console.log('Request Body - ', requestBody)
        const options = {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + jwtBearer,
                'Content-Type': 'application/json' // Set content type to JSON
            },
            body: JSON.stringify(requestBody) // Wrap requestBody as needed
        }

        try {
            const response = await fetch(
                `${DIGITAL_JOURNEY_BASE_URL}portal/crif/request/`,
                options
            )
            console.log('Request Options - ', options)
            console.log('Response -- ', response)
            return response.json() // Assuming the response is JSON
        } catch (error) {
            console.log('Error', error)
            alert(error.message)
            throw error
        }
    }
)

const fetchBureauSlice = createSlice({
    name: 'fetchBureau',
    initialState: {
        isLoading: false,
        data: null,
        isError: false,
        errorMessage: null
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchBureau.pending, state => {
            state.isLoading = true
            state.isError = false
            state.errorMessage = null
        })
        builder.addCase(fetchBureau.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
            state.isError = false
            state.errorMessage = null
        })
        builder.addCase(fetchBureau.rejected, (state, action) => {
            state.isLoading = false
            state.isError = true
            state.errorMessage = action.error.message
        })
    }
})

export default fetchBureauSlice.reducer
